const BUILD_ID = process.env.REACT_APP_BUILD_ID;
const POLL_INTERVAL_MS = 5 * 60 * 1000;

export type DeployUpdateHandler = () => void;

async function fetchServerBuildId(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return data.buildId || null;
  } catch {
    return null;
  }
}

/**
 * Polls /version.json; calls onUpdateAvailable when CI has deployed a newer build.
 * Skips in dev and when no build id was baked into the bundle.
 */
export function startDeployVersionCheck(onUpdateAvailable: DeployUpdateHandler): void {
  if (!BUILD_ID || process.env.NODE_ENV === "development") {
    return;
  }

  let notified = false;

  const check = async () => {
    const serverBuildId = await fetchServerBuildId();
    if (!serverBuildId || serverBuildId === BUILD_ID) return;
    if (!notified) {
      notified = true;
      onUpdateAvailable();
    }
  };

  check();
  window.setInterval(check, POLL_INTERVAL_MS);
}
